import { PromoBanner } from "@similarweb/ui-components";

import { StyledRowSuccessPromoBanner } from "./styles";

type Props = {
    title: string;
    subTitle: string;
};

const SuccessBannerRow = ({ title, subTitle }: Props) => {
    return (
        <StyledRowSuccessPromoBanner data-automation="feature-upgrade-banner-row-success">
            <PromoBanner.Image
                iconName="balloon"
                iconSize="56px"
            />

            <PromoBanner.Content>
                <PromoBanner.Title>{title}</PromoBanner.Title>
                <PromoBanner.Description>{subTitle}</PromoBanner.Description>
            </PromoBanner.Content>
        </StyledRowSuccessPromoBanner>
    );
};

export default SuccessBannerRow;
